export enum TransactionType {
  PURCHASE = 'PURCHASE',
}
